var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.query.roletype && _vm.$route.query.roletype == 'pharmacist')?_c('corporate-view'):_c('customer-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }